import React, {PropTypes, Component} from 'react';
import { Icon } from 'infl-icons';
import SaveButton from 'patternity/lib/save-button';

class InflunetBanner extends Component {
  propTypes: {
    deepLinkManager: React.PropTypes.object.isRequired,
    rating: React.PropTypes.number.isRequired,
    image: React.PropTypes.string.isRequired
  };

  constructor(props) {
    super(props)

    this.state = {
      shouldShow: true,
      getting: false
    };

    this._close = this._close.bind(this);
    this._getApp = this._getApp.bind(this);
  }

  render() {
    if (!this.state.shouldShow) {
      return false;
    }

    return (
      <div style={this.styles.container}>
        <div style={this.styles.close} onClick={this._close}>
          <div style={this.styles.closeIcon}>
            <Icon icon={"times"} />
          </div>
        </div>
        <div style={this.styles.promo}>
          <img style={this.styles.appIcon} src={this.props.image} />
          {this._renderButton()}
          <div style={this.styles.info}>
            <div style={this.styles.title}>AdvocateHub</div>
            {this._renderStars()}
          </div>
        </div>
        <div style={this.styles.description}>Complete challenges and earn rewards on the go!</div>
      </div>
    );
  }

  _renderButton() {
    var customText = {
      unsaved: 'Get the App',
      saving: ''
    }

    var state = this.state.getting ? 'saving' : 'unsaved';

    return (
      <div style={this.styles.button}>
        <SaveButton saveStatus={state} customText={customText} onClick={this._getApp} />
      </div>
    )
  }

  _renderStars() {
    var rating = this.props.rating;
    var stars = [];

    for(var i = 0; i < 5; i++) {
      if (rating >= 1) {
        stars.push(this._renderStar(this.starStyles.full, i));
        rating--;
      } else if (rating > 0) {
        stars.push(this._renderStar(this._partialStarStyle(rating), i));
        rating = 0;
      } else {
        stars.push(this._renderStar(this.starStyles.empty, i));
      }
    }

    return (
      <div style={this.styles.rating}>
        {stars}
      </div>
    );
  }

  _renderStar(style, index) {
    return (
      <div style={this.starStyles.stencil} key={index + "stencil"}>
        ☆
        <span style={style} key={index + "filled"}>★</span>
      </div>
    );
  }

  _close() {
    this.props.deepLinkManager.bannerWasClosed();
    this.setState({ shouldShow: false });
  }

  _getApp() {
    this._startSpinner();

    var that = this;
    this.props.deepLinkManager.bannerLink(function() {
      that._stopSpinner();
    });
  }

  _startSpinner() {
    this.setState({ getting: true });
  }

  _stopSpinner() {
    this.setState({ getting: false });
  }

  styles = {
    container: {
      backgroundColor: '#ffffff',
      height: '76px',
      overflow: 'hidden'
    },
    close: {
      float: 'left',
      height: '100%'
    },
    closeIcon: {
      fontSize: '16px',
      padding: '27px 6px'
    },
    promo: {
      height: '56px'
    },
    appIcon: {
      float: 'left',
      width: '44px',
      height: '44px',
      paddingTop: '8px'
    },
    info: {
      marginLeft: '85px',
      marginRight: '122px',
      overflow: 'hidden',
      paddingTop: '15px'
    },
    title: {
      fontWeight: 'bold',
      color: '#555555',
      fontSize: '12px',
      lineHeight: '15px'
    },
    rating: {
      fontSize: '13px',
      color: '#777777'
    },
    button: {
      float: 'right',
      marginRight: '12px',
      marginTop: '15px',
    },
    description: {
      fontSize: '11px',
      color: '#777777',
      position: 'relative',
      bottom: '3px'
    }
  }

  starStyles = {
    stencil: {
      color: '#777777',
      position: 'relative',
      display: 'inline-block'
    },
    empty: {
      display: 'none'
    },
    full: {
      color: '#555555',
      position: 'absolute',
      top: '0',
      left: '0'
    }
  }

  _partialStarStyle(fraction) {
    return {
      width: fraction*100 + '%',
      color: '#555555',
      position: 'absolute',
      top: '0',
      left: '0',
      overflow: 'hidden'
    }
  }
};

export default InflunetBanner;



// WEBPACK FOOTER //
// ./src/advocate/components/influnet_promotion/banner.jsx